import find from "ramda/src/find"
import propEq from "ramda/src/propEq"
import _concat from "lodash/concat"
import _filter from "lodash/filter"
import _find from "lodash/find"
import _flattenDeep from "lodash/flatten"
import _get from "lodash/get"
import _head from "lodash/head"
import _map from "lodash/map"
import _sortBy from "lodash/sortBy"
import { get, post, put, remove } from "services/network/endpoint"
import { getCookie, setCookie } from "services/utils/cookie"
import {
  dispatchHandler,
  normalizeTargetSystem,
  success
} from "services/utils/action"
import * as ActionTypes from "services/state/action-types"
import { isSameObject } from "services/utils/isSameObject"
import { saveOperation } from "../experience/action"
import { BFF } from "services/network/routes"
import ENV from "../../../envProperties"
import { EMAIL, DUPLICATE } from "./constants"
import { formValueSelector } from "redux-form"
import moment from "moment"
import "moment/locale/pt-br"
import { selectBillFromStorage } from "services/utils/selectBillFromStorage"
import { sendGtmEventFileDownload } from "services/utils/sendGtm"

moment.locale("pt-br")

const BASIC = ENV.API_SENSEDIA_BASIC_CUSTOM
const CLIENT_ID = ENV.API_SENSEDIA_CLIENT_ID_CUSTOM

export function filterOpenInvoices(term) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.FILTER_OPEN_INVOICES,
      payload: { term }
    })
  }
}

export function filterDueInvoices(term) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.FILTER_DUE_INVOICES,
      payload: { term }
    })
  }
}

export function filterNextInvoices(term) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.FILTER_NEXT_INVOICES,
      payload: { term }
    })
  }
}

export function filterClosedInvoices(term) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.FILTER_CLOSED_INVOICES,
      payload: { term }
    })
  }
}

export function resetInvoicesFilter() {
  return (dispatch) => {
    dispatch(filterOpenInvoices(""))
    dispatch(filterDueInvoices(""))
    dispatch(filterNextInvoices(""))
    dispatch(filterClosedInvoices(""))
  }
}

export function getInvoices({ accountNumber }) {
  return async (dispatch, getState) => {
    const { selected } = getState().bills
    const { agreementId, billingSystem } = selected
    const targetSystem = normalizeTargetSystem(selected)

    const config = {
      pathValues: { accountNumber },
      params: { agreementId, targetSystem, billingSystem },
      client: BFF
    }

    const request = get("invoices", config)

    dispatch({
      type: ActionTypes.GET_INVOICES,
      payload: request
    }).then((resp) => {
      dispatch(resetInvoicesFilter())
    })
  }
}

export function selectBill(bill) {
  return (dispatch) => {
    if (!bill) return undefined

    dispatch({
      type: ActionTypes.SELECT_BILL,
      payload: bill
    })

    setCookie("accountNumber", bill.accountNumber)
  }
}

function findBillByAccountNumber(bills, accountNumber) {
  return find(propEq("accountNumber", accountNumber), bills)
}

function selectBillByAccountNumber(bills, accountNumber) {
  return (dispatch) => {
    const selected = findBillByAccountNumber(bills, accountNumber)

    const oldSelectedBill = selectBillFromStorage()

    const isSame = isSameObject(selected, oldSelectedBill)

    if (!isSame) {
      window.localStorage.setItem("selectBill", JSON.stringify(selected))
      dispatch(selectBill(selected))
      return
    }

    if (oldSelectedBill) {
      dispatch(selectBill(oldSelectedBill))
      return
    }

    if (selected) {
      dispatch(selectBill(selected))
      return
    }

    dispatch(selectDefaultBill(bills))
  }
}

function selectDefaultBill([bill]) {
  return (dispatch) => dispatch(selectBill(bill))
}

export function getBills(
  accountNumber = getCookie("accountNumber"),
  documentNumber = ""
) {
  return (dispatch) => {
    const request = get("bills", {
      client: BFF,
      params: { documentNumberQuery: documentNumber }
    })

    dispatch({
      type: ActionTypes.GET_BILLS,
      payload: request
    }).then(
      success((response) => {
        const bills = _sortBy(response.payload.data, (data) => data.status)
        accountNumber
          ? dispatch(selectBillByAccountNumber(bills, accountNumber))
          : dispatch(selectDefaultBill(bills))
      })
    )
  }
}

export function getBillsByDocumentNumber(
  documentNumber = "",
  callbackSuccess,
  callbackError
) {
  return (dispatch) => {
    const request = get("bills", {
      client: BFF,
      params: { documentNumberQuery: documentNumber }
    })

    dispatch({
      type: ActionTypes.GET_BILLS_BY_DOCUMENT_NUMBER,
      payload: request
    }).then(dispatchHandler(callbackSuccess, callbackError))
  }
}

function getSystemBilling(invoices, id) {
  const findSelectedInvoice = _find(invoices, (item) => item.id === id)
  const systemBilling = _get(findSelectedInvoice, "systemBilling", "")
  return systemBilling
}

function normalizeInvoiceFileConfig(
  products,
  bills,
  customer,
  invoices,
  id,
  fileType,
  email,
  requestType = "GET",
  format
) {
  const { selected } = bills
  const { accountNumber, agreementId } = selected
  const invoiceKey = btoa(id)
  const targetSystem = normalizeTargetSystem(selected)
  const systemBilling = getSystemBilling(invoices, id)
  const name = customer.name
  const customerSegment = customer.customerSegment
  const invoice = _find(invoices, { id })
  const account =
    _find(bills.data, (b) => b.accountNumber === invoice.billingAccount) || {}
  const product = _head(
    _flattenDeep(
      _map(products.data, (p) =>
        _filter(
          p.products,
          (pp) =>
            `${pp.agreementId}` === `${account.agreementId}`.replace(/\D/g, "")
        )
      )
    )
  )
  const paymentMode = _get(product, "paymentMode", "POSPAGO")
  const paymentType = paymentMode === "PREPAGO" || paymentMode === "CONTROLE"
  const phoneNumber = _get(product, "serviceId", "")

  const dueDate =
    invoice && invoice.dueDate && moment(invoice.dueDate).isValid()
      ? moment(invoice.dueDate).format("DD/MM/YYYY")
      : ""

  if (requestType === "POST") {
    return {
      pathValues: { accountNumber, invoiceKey },
      data: {
        fileType,
        email,
        agreementId,
        targetSystem,
        systemBilling: "KENAN",
        name,
        customerSegment,
        dueDate,
        isHugeInvoice: invoice.isHugeInvoice,
        invoiceId: id,
        billingAccount: accountNumber,
        paymentMode,
        format,
        monthYear:
          paymentType && dueDate
            ? `${dueDate.split("/")[1]}/${dueDate.split("/")[2]}`
            : "",
        phoneNumber: paymentType && phoneNumber ? +phoneNumber.toString() : ""
      }
    }
  }

  return {
    pathValues: { accountNumber, invoiceKey },
    params: { fileType, email, agreementId, targetSystem, systemBilling }
  }
}

function normalizeOpenInvoiceConfig(
  products,
  bills,
  customer,
  customerOpenInvoices,
  id,
  fileType,
  email,
  index,
  format
) {
  const invoices = _get(customerOpenInvoices, "data", {})
  const selectedInvoice = index
    ? invoices[index]
    : _find(invoices, (item) => item.id === id)
  const { billingAccount, crmCliente } = selectedInvoice
  const accountNumber = billingAccount
  const targetSystem = crmCliente
  const systemBilling = "KENAN"
  const account =
    _find(
      bills.data,
      (b) => b.accountNumber === selectedInvoice.billingAccount
    ) || {}
  const product = _find(products.data, (p) =>
    _find(
      p.products,
      (pp) =>
        `${pp.agreementId}` === `${account.agreementId}`.replace(/\D/g, "")
    )
  )
  const dueDate =
    selectedInvoice &&
    selectedInvoice.dueDate &&
    moment(selectedInvoice.dueDate).isValid()
      ? moment(selectedInvoice.dueDate).format("DD/MM/YYYY")
      : ""
  const paymentMode = _get(product, "products.0.paymentMode", "")
  const phoneNumber = _get(product, "products.0.serviceId", "")

  if (email) {
    return {
      data: {
        fileType,
        email,
        targetSystem,
        systemBilling,
        name: customer.name,
        customerSegment: customer.customerSegment,
        dueDate,
        isHugeInvoice: selectedInvoice.isHugeInvoice,
        invoiceId: id,
        billingAccount: accountNumber,
        paymentMode,
        agreementId: account.agreementId,
        format,
        monthYear:
          paymentMode &&
          (paymentMode === "PREPAGO" || paymentMode === "CONTROLE") &&
          dueDate
            ? `${dueDate.split("/")[1]}/${dueDate.split("/")[2]}`
            : undefined,
        phoneNumber:
          paymentMode &&
          (paymentMode === "PREPAGO" || paymentMode === "CONTROLE") &&
          phoneNumber
            ? +phoneNumber.toString()
            : undefined
      }
    }
  }

  return {
    data: {
      fileType,
      targetSystem,
      systemBilling,
      name: customer.name,
      customerSegment: customer.customerSegment,
      dueDate,
      isHugeInvoice: selectedInvoice.isHugeInvoice,
      invoiceId: id,
      billingAccount: accountNumber,
      paymentMode,
      agreementId: account.agreementId,
      format,
      monthYear:
        paymentMode &&
        (paymentMode === "PREPAGO" || paymentMode === "CONTROLE") &&
        dueDate &&
        `${dueDate.split("/")[1]}/${dueDate.split("/")[2]}`,
      phoneNumber:
        paymentMode &&
        (paymentMode === "PREPAGO" || paymentMode === "CONTROLE") &&
        phoneNumber
          ? +phoneNumber.toString()
          : undefined
    }
  }
}

export function downloadCountsPosPaid(payloads = []) {
  const links = []
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.MONTHS_LOADER,
      payload: true
    })

    for (const detail of payloads) {
      const request = post("downloadFileDetails", {
        data: detail,
        client: BFF,
        responseType: "blob"
      })

      dispatch({
        type: ActionTypes.MONTHS_DETAILING_DOWNLOAD,
        payload: request
      })
        .then((response) => {
          return {
            blob: new Blob([response.payload.data], {
              type: response.payload.headers["content-type"]
            }),
            filename:
              response.payload.headers["content-type"] ===
              "application/octet-stream"
                ? "DETALHAMENTOS.zip"
                : ""
          }
        })
        .then((response) => {
          const url = window.URL.createObjectURL(response.blob)
          const link = document.createElement("a")
          link.href = url
          link.target = "_blank"
          link.download = `DETALHAMENTO_${detail.monthYear}`
          links.push(link)
          if (links.length === payloads.length) {
            for (const link of links) {
              document.body.appendChild(link)
              link.click()
              link.parentNode.removeChild(link)
            }

            sendGtmEventFileDownload("Download de detalhamento pós-pago")

            saveOperation(
              getState().customer.data,
              "",
              "DETAILING_POS",
              "DOWNLOAD",
              "SUCCESS",
              "",
              "Download de detalhamento pós-pago"
            )

            dispatch({
              type: ActionTypes.MONTHS_LOADER,
              payload: false
            })
          }
        })
        .catch((error) => {
          dispatch(
            saveOperation(
              getState().customer.data,
              "",
              "DETAILING_POS",
              "DOWNLOAD",
              "ERROR",
              "",
              "Download de detalhamento pós-pago"
            )
          )

          dispatch({
            type: ActionTypes.MONTHS_LOADER,
            payload: false
          })
          console.error("Error: ", error)
        })
    }
  }
}

function normalizeOpenInvoiceSendEmail(
  state,
  historicInvoices,
  id,
  fileType,
  email
) {
  const customerData = _get(state, "customer.data", {})
  const selectedInvoice = _find(historicInvoices, (item) => item.id === id)
  const { billingAccount, crmCliente } = selectedInvoice
  const accountNumber = billingAccount
  const targetSystem = crmCliente
  const systemBilling = "KENAN"

  return {
    data: {
      fileType,
      email,
      targetSystem,
      systemBilling,
      name: customerData.name,
      customerSegment: customerData.customerSegment,
      dueDate: selectedInvoice.dueDate,
      isHugeInvoice: selectedInvoice.isHugeInvoice,
      invoiceId: id,
      billingAccount: accountNumber
    }
  }
}

export function sendInvoiceByEmail(
  products,
  bills,
  customer,
  invoices,
  invoice,
  fileType = EMAIL,
  email,
  format
) {
  return (dispatch, getState) => {
    const config = normalizeInvoiceFileConfig(
      products,
      bills,
      customer,
      invoices,
      invoice.id,
      fileType,
      email,
      "POST",
      format
    )

    config.client = BFF

    const request = post("sendInvoiceByEmail", config)

    dispatch({
      type: ActionTypes.SEND_INVOICE_BY_EMAIL,
      payload: request
    })
      .then(
        success((action) => {
          dispatch(
            saveOperation(
              getState().customer.data,
              invoice.id,
              "INVOICE",
              "EMAIL",
              "SUCCESS",
              "",
              "Fatura"
            )
          )

          dispatch({ type: ActionTypes.INVOICE_ASYNC_DOWNLOAD_NOTIFICATION })
        })
      )
      .catch((error) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            invoice.id,
            "INVOICE",
            "EMAIL",
            "ERROR",
            "",
            "Fatura"
          )
        )
        console.error("Error: ", error)
      })
  }
}
export function sendOpenInvoiceByEmail(
  historicInvoices,
  invoice,
  fileType = EMAIL,
  email,
  index
) {
  return (dispatch, getState) => {
    const config = normalizeOpenInvoiceSendEmail(
      getState(),
      historicInvoices,
      invoice.id,
      fileType,
      email,
      index
    )
    const request = post("sendInvoiceByEmail", { ...config, client: BFF })

    dispatch({
      type: ActionTypes.SEND_INVOICE_BY_EMAIL,
      payload: request
    })
      .then(
        success((action) => {
          saveOperation(
            getState().customer.data,
            invoice.id,
            "INVOICE",
            "EMAIL",
            "SUCCESS",
            "",
            "Fatura"
          )

          dispatch({ type: ActionTypes.INVOICE_ASYNC_DOWNLOAD_NOTIFICATION })
        })
      )
      .catch((error) => {
        console.error(error)

        saveOperation(
          getState().customer.data,
          invoice.id,
          "INVOICE",
          "EMAIL",
          "ERROR",
          "",
          "Fatura"
        )
      })
  }
}
export function downloadInvoiceLarge(invoices, fileType = DUPLICATE, email) {
  return (dispatch, getState) => {
    const customerData = getState().customer.data
    const data = {
      invoicesToDownload: invoices
    }

    const config = {
      pathValues: {
        customerKey: btoa(customerData.documentNumber)
      },
      params: {
        fileType,
        originSystem: "PORTAL_B2B",
        email
      },
      data
    }

    const request = post("downloadInvoiceLarge", config)

    return dispatch({
      type: ActionTypes.DOWNLOAD_INVOICE_LARGE,
      payload: request
    })
      .then((resp) => {
        saveOperation(
          customerData,
          "",
          "INVOICE",
          "DOWNLOAD_MANY",
          "SUCCESS",
          "",
          "Fatura"
        )
        return resp.payload
      })
      .catch((error) => {
        console.error(error)

        saveOperation(
          customerData,
          "",
          "INVOICE",
          "DOWNLOAD_MANY",
          "ERROR",
          "",
          "Fatura"
        )
      })
  }
}

export function getPixInvoice(invoice) {
  return (dispatch, getState) => {
    const request = get("getPixInvoice", {
      params: { invoiceKey: invoice.id }
    })

    return dispatch({
      type: ActionTypes.GET_INVOICE_PIX,
      payload: request
    })
      .then((resp) => {
        if (!(resp && resp.payload)) {
          dispatch(
            saveOperation(
              getState().customer.data,
              invoice.id,
              "INVOICE",
              "VIEW_QRCODE",
              "ERROR",
              "",
              "Fatura"
            )
          )
          return { base64: "", linhaDigitavel: "" }
        }
        const { base64, linhaDigitavel } = resp.payload
        const statusExperience =
          base64 && linhaDigitavel ? "SUCCESS" : "WARNING"
        dispatch(
          saveOperation(
            getState().customer.data,
            invoice.id,
            "INVOICE",
            "VIEW_QRCODE",
            statusExperience,
            "",
            "Fatura"
          )
        )
        dispatch({ type: ActionTypes.GET_INVOICE_PIX_SUCCESS })
        return resp.payload
      })
      .catch((error) => {
        console.error(error)

        dispatch({ type: ActionTypes.GET_INVOICE_PIX_ERROR })
        dispatch(
          saveOperation(
            getState().customer.data,
            invoice.id,
            "INVOICE",
            "VIEW_QRCODE",
            "ERROR",
            "",
            "Fatura"
          )
        )

        return { base64: "", linhaDigitavel: "" }
      })
  }
}

export function getInvoiceBarCode(invoice) {
  return (dispatch, getState) => {
    const request = get("getInvoiceBarCode", {
      pathValues: { billingAccountNumber: invoice.billingAccount },
      params: { invoiceId: invoice.id, billingSystem: "KENAN" }
    })

    return dispatch({
      type: ActionTypes.GET_INVOICE_BARCODE,
      payload: request
    })
      .then((resp) => {
        if (!(resp && resp.payload)) {
          dispatch(
            saveOperation(
              getState().customer.data,
              invoice.id,
              "INVOICE",
              "VIEW_BARCODE",
              "ERROR",
              "",
              "FATURA B2B"
            )
          )
          return { barCode: "" }
        }

        dispatch(
          saveOperation(
            getState().customer.data,
            invoice.id,
            "INVOICE",
            "VIEW_BARCODE",
            "SUCCESS",
            "",
            "FATURA B2B"
          )
        )
        dispatch({ type: ActionTypes.GET_INVOICE_BARCODE_SUCCESS })
        return resp.payload
      })
      .catch((error) => {
        console.error(error)

        dispatch({ type: ActionTypes.GET_INVOICE_BARCODE_ERROR })
        dispatch(
          saveOperation(
            getState().customer.data,
            invoice.id,
            "INVOICE",
            "VIEW_QRCODE",
            "ERROR",
            "",
            "FATURA B2B"
          )
        )

        return { barCode: "" }
      })
  }
}

const onDownloadInvoiceSuccess = async (
  response,
  config,
  dispatch,
  invoice,
  customer,
  requestType,
  format
) => {
  window.log("onDownloadInvoiceSuccess", { invoice, config, response })

  sendGtmEventFileDownload(`Fatura - ${requestType}`)

  dispatch(
    saveOperation(
      customer,
      invoice.id,
      "INVOICE",
      requestType,
      "SUCCESS",
      "",
      "Fatura"
    )
  )

  if (response.payload.data.pathURL) {
    if (invoice.systemBilling === "CPQD") {
      window.location = response.payload.data.pathURL
      return
    }

    if (/swift/.test(response.payload.data.pathURL)) {
      const request = get("downloadHugeInvoice", {
        params: {
          pathURL: response.payload.data.pathURL
        },
        headers: {
          "Content-Type": "application/pdf"
        },
        responseType: "blob"
      })
      dispatch({
        type: ActionTypes.DOWNLOAD_HUGE_INVOICE,
        payload: request
      })
        .then(
          (response) =>
            new Blob([response.payload.data], { type: "application/pdf" })
        )
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.target = "_blank"
          link.setAttribute("download", `2via.pdf`)

          document.body.appendChild(link)

          link.click()
          link.parentNode.removeChild(link)
        })
        .catch((err) => console.error(err))
      return
    }

    const request = get("downloadFileInvoice", {
      params: {
        pathURL: response.payload.data.pathURL
      },
      headers: {
        "Content-Type": "application/pdf"
      },
      responseType: "blob"
    })
    dispatch({
      type: ActionTypes.DOWNLOAD_HUGE_INVOICE,
      payload: request
    })
      .then(
        (response) =>
          new Blob([response.payload.data], {
            type: response.payload.data.type
          })
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.target = "_blank"
        link.setAttribute("download", requestType)

        document.body.appendChild(link)

        link.click()
        link.parentNode.removeChild(link)
      })
      .catch((err) => console.error(err))
    return
  }

  dispatch({ type: ActionTypes.INVOICE_ASYNC_DOWNLOAD_NOTIFICATION })
}

export function downloadInvoice(
  products,
  bills,
  customer,
  invoices,
  invoice,
  fileType = DUPLICATE,
  format
) {
  return (dispatch, getState) => {
    const config = normalizeInvoiceFileConfig(
      products,
      bills,
      customer,
      invoices,
      invoice.id,
      fileType,
      undefined,
      "POST",
      format
    )
    const request = post("downloadInvoice", {
      ...config,
      useMock: formValueSelector,
      client: BFF
    })

    let requestType
    if (fileType === "DUPLICATE") {
      requestType = "2VIA"
    } else if (fileType === "BILLET") {
      requestType = "BILLET"
    } else if (fileType === "EXCEL") {
      requestType = "DETAILS_EXCEL"
    } else if (fileType === "ACCOUNT_DETAILS") {
      requestType = "DETAILS"
    }

    dispatch({
      type: ActionTypes.DOWNLOAD_INVOICE,
      payload: request
    }).then(
      dispatchHandler(
        (response) =>
          onDownloadInvoiceSuccess(
            response,
            config,
            dispatch,
            invoice,
            getState().customer.data,
            requestType,
            format
          ),
        (error) => {
          dispatch(
            saveOperation(
              getState().customer.data,
              invoice.id,
              "INVOICE",
              requestType,
              "ERROR",
              "",
              "Fatura"
            )
          )
          console.error("Error: ", error)
        }
      )
    )
  }
}

export const resetDownloadMultipleInvoices = () => ({
  type: ActionTypes.DOWNLOAD_MULTIPLE_INVOICES_RESET
})

export function downloadAllOpenInvoices(
  products,
  bills,
  customer,
  customerOpenInvoices,
  fileType = DUPLICATE
) {
  return (dispatch) => {
    const allInvoicesUrl = []
    customerOpenInvoices.data.forEach((invoice, index) => {
      const config = normalizeOpenInvoiceConfig(
        products,
        bills,
        customer,
        customerOpenInvoices,
        invoice.id,
        fileType,
        null,
        index,
        "PDF"
      )
      allInvoicesUrl.push(config.data)
    })
    const request = post("downloadMultipleInvoices", {
      data: {
        invoices: [...allInvoicesUrl]
      },
      client: BFF,
      responseType: "blob"
    })

    dispatch({
      type: ActionTypes.DOWNLOAD_MULTIPLE_INVOICES,
      payload: request
    })
      .then((response) => {
        const failedInvoicesHeader =
          response.payload.headers["x-failed-invoices"]

        const failedInvoices = failedInvoicesHeader
          ? JSON.parse(failedInvoicesHeader)
          : []

        const result = {
          blob: new Blob([response.payload.data], {
            type: response.payload.headers["content-type"]
          }),
          fileName:
            response.payload.headers["content-type"] ===
            "application/octet-stream"
              ? "FATURAS.zip"
              : "FATURA.pdf",
          failedInvoices
        }

        dispatch({
          type: ActionTypes.DOWNLOAD_MULTIPLE_INVOICES_SUCCESS,
          payload: result
        })

        return result
      })
      .then((response) => {
        dispatch(
          saveOperation(
            customer,
            "",
            "INVOICE",
            "DOWNLOAD_MANY",
            "SUCCESS",
            "",
            "Download de faturas em lote"
          )
        )

        const url = window.URL.createObjectURL(response.blob)
        const link = document.createElement("a")
        link.href = url
        link.target = "_blank"
        if (response.fileName) {
          link.download = response.fileName
        }
        document.body.appendChild(link)

        link.click()
        link.parentNode.removeChild(link)
      })
      .catch((err) => {
        console.error(err)
        saveOperation(
          customer,
          "",
          "INVOICE",
          "DOWNLOAD_MANY",
          "ERROR",
          "",
          "Download de faturas em lote"
        )
      })

    return Promise.resolve()
  }
}

export function downloadOpenInvoice(
  products,
  bills,
  customer,
  customerOpenInvoices,
  invoice,
  fileType = DUPLICATE,
  index,
  format
) {
  return (dispatch, getState) => {
    const config = normalizeOpenInvoiceConfig(
      products,
      bills,
      customer,
      customerOpenInvoices,
      invoice.id,
      fileType,
      null,
      index,
      format
    )
    const request = post("downloadInvoice", { ...config, client: BFF })
    let requestType

    if (fileType === "DUPLICATE") {
      saveOperation(
        getState().customer.data,
        "",
        "FATURAS_SEGUNDA_VIA",
        "CLICK",
        "PENDING",
        "",
        "Acesso à 2ª via de fatura - Tela de Faturas"
      )

      requestType = "2VIA"
    } else if (fileType === "BILLET") {
      saveOperation(
        getState().customer.data,
        "",
        "FATURAS_BOLETO",
        "CLICK",
        "PENDING",
        "",
        "Geração de boleto - Tela de Faturas"
      )

      requestType = "BILLET"
    } else if (fileType === "EXCEL") {
      saveOperation(
        getState().customer.data,
        "",
        "FATURAS_EXPORTAR_EXCEL",
        "CLICK",
        "PENDING",
        "",
        "Exportação detalhamento Excel - Tela de Faturas"
      )

      requestType = "DETAILS_EXCEL"
    } else if (fileType === "ACCOUNT_DETAILS") {
      saveOperation(
        getState().customer.data,
        "",
        "FATURAS_DETALHAMENTO",
        "CLICK",
        "PENDING",
        "",
        "Visualização detalhamento de fatura - Tela de Faturas"
      )

      requestType = "DETAILS"
    }

    dispatch({
      type: ActionTypes.DOWNLOAD_INVOICE,
      payload: request
    }).then(
      dispatchHandler(
        (response) =>
          onDownloadInvoiceSuccess(
            response,
            config,
            dispatch,
            invoice,
            getState().customer.data,
            requestType
          ),
        () => {
          saveOperation(
            getState().customer.data,
            invoice.id,
            "INVOICE",
            requestType,
            "ERROR",
            "",
            "Fatura"
          )
        }
      )
    )
  }
}

export function dismissInvoiceDownloadNotification() {
  return (dispatch) => {
    dispatch({ type: ActionTypes.INVOICE_ASYNC_DOWNLOAD_NOTIFICATION_DISMISS })
  }
}

export function getFebrabanAccounts(params) {
  return (dispatch, getState) => {
    const accountNumber = getState().bills.selected.accountNumber
    const billingSystem = getState().bills.selected.billingSystem

    params = {
      ...params,
      accountNumber,
      billingSystem
    }

    const request = get("febrabanAccounts", {
      pathValues: { accountNumber },
      params
    })

    return dispatch({
      type: ActionTypes.GET_FEBRABAN_ACCOUNTS,
      payload: request
    })
  }
}

export function clearFebrabanList() {
  return (dispatch) => {
    return dispatch({
      type: ActionTypes.CLEAR_FEBRABAN
    })
  }
}

export function downloadFebrabanAccount({
  account,
  startDate,
  expirationDate
}) {
  return (dispatch, getState) => {
    const invoiceId = account.invoiceId
    const file = _find(
      getState().febraban.data,
      (item) => item.invoiceId === invoiceId
    )

    if (!file) return

    const request = get("downloadFileInvoice", {
      params: {
        pathURL: file.pathUrl
      },
      headers: {
        "Content-Type": "application/zip"
      },
      responseType: "blob"
    })

    const webDavPathPartitioned = file.fileName.split("/")
    const fileName = webDavPathPartitioned[webDavPathPartitioned.length - 1]

    dispatch({
      type: ActionTypes.DOWNLOAD_HUGE_INVOICE,
      payload: request
    })
      .then(
        (response) =>
          new Blob([response.payload.data], { type: "application/zip" })
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.target = "_blank"
        link.setAttribute("download", fileName)

        document.body.appendChild(link)

        link.click()
        link.parentNode.removeChild(link)
      })
      .catch((err) => console.error(err))

    return Promise.resolve()
  }
}

export function getProducts(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = { pathValues: queryParams, client: BFF }
    const request = get("productsAll", config)

    return dispatch({
      type: ActionTypes.GET_PRODUCTS,
      payload: request
    }).then((res) => {
      const resultAssets = res.payload.data.resultAssets
      const hasActiveProduct = resultAssets.find(
        (item) => item.status === "ATIVO"
      )

      if (!hasActiveProduct) {
        window.localStorage.setItem("inactiveProducts", "true")
      } else {
        window.localStorage.setItem("inactiveProducts", "false")
      }

      return dispatchHandler(callback, callbackFail)(res)
    })
  }
}

export function getProductsSilent(params = {}, callback, callbackError) {
  return (dispatch) => {
    const config = { params, client: BFF }
    const request = get("productsAll", config)

    return dispatch({
      type: ActionTypes.GET_PRODUCTS,
      payload: request,
      meta: { silent: true }
    }).then(dispatchHandler(callback, callbackError))
  }
}

export function getProductsSubsidiary(
  documentNumberSubsidiary,
  callback,
  callbackError
) {
  return (dispatch) => {
    const config = { pathValues: { documentNumberSubsidiary }, client: BFF }
    const request = get("productsAllSubsidiary", config)

    return dispatch({
      type: ActionTypes.GET_PRODUCTS_SUBSIDIARY,
      payload: request
    }).then(dispatchHandler(callback, callbackError))
  }
}

export function getProductsSubsidiarySilent(
  documentNumberSubsidiary,
  callback,
  callbackError
) {
  return (dispatch) => {
    const config = {
      pathValues: { documentNumberSubsidiary },
      params: { application: "PORTAL" },
      client: BFF
    }

    const request = get("productsAllSubsidiary", config)

    return dispatch({
      type: ActionTypes.GET_PRODUCTS,
      payload: request,
      meta: { silent: true }
    }).then(dispatchHandler(callback, callbackError))
  }
}

export function getBlockedProducts(callback, callbackFail) {
  return (dispatch, getState) => {
    const customerId = _get(getState().customer, "data.documentNumber", "")
    const config = {
      pathValues: { customerId },
      client: BFF,
      data: {}
    }
    const request = get("getBlockedProducts", config)

    return dispatch({
      type: ActionTypes.GET_BLOCKED_PRODUCTS,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getProductDetail(selectedProduct, callback) {
  const { productSystem, productId, agreementId, serviceId } = selectedProduct

  return (dispatch) => {
    const config = {
      pathValues: {
        productId,
        agreementId,
        serviceId,
        crmSystem: productSystem
      },
      client: BFF
    }

    let request = get("productDetail", config)

    if (productSystem === "ALGAR CRM") {
      const headers = {
        "Content-Type": "application/json",
        client_id: CLIENT_ID,
        Authorization: BASIC
      }
      const targetSystem = productSystem
      const config = {
        pathValues: {
          productId,
          crmSystem: targetSystem,
          agreementId,
          serviceId
        },
        headers,
        client: BFF
      }
      request = get("productDetail", config)
    }

    return dispatch({
      type: ActionTypes.GET_PRODUCT_DETAIL,
      payload: request
    }).then(success(callback))
  }
}

export function canCancelProduct({ serviceId }, callback) {
  return (dispatch, getState) => {
    const config = { raw: true }
    const request = get("canCancel", config)

    return dispatch({
      type: ActionTypes.CAN_CANCEL,
      payload: request
    })
      .then(success(callback))
      .then(function (response) {
        const currentState = getState()
        const stateCode = _get(response, "error.response.data.stateCode", "")
        if (stateCode === "ALREADY_EXISTS") {
          dispatch(
            saveOperation(
              currentState.customer.data,
              serviceId,
              "PRODUCT_CANCELLATION",
              "VERIFY",
              "WARNING",
              "",
              "Verificação de Cancelamento"
            )
          )
        } else if (response.type === "CAN_CANCEL_FAIL") {
          dispatch(
            saveOperation(
              currentState.customer.data,
              serviceId,
              "PRODUCT_CANCELLATION",
              "VERIFY",
              "ERROR",
              "",
              "Verificação de Cancelamento"
            )
          )
        } else {
          dispatch(
            saveOperation(
              currentState.customer.data,
              serviceId,
              "PRODUCT_CANCELLATION",
              "VERIFY",
              "SUCCESS",
              "",
              "Verificação de Cancelamento"
            )
          )
        }
      })
      .catch(function (e) {
        console.error("ERROR: ", e)
        const currentState = getState()
        dispatch(
          saveOperation(
            currentState.customer.data,
            serviceId,
            "PRODUCT_CANCELLATION",
            "VERIFY",
            "ERROR",
            "",
            "Verificação de Cancelamento"
          )
        )
        throw e
      })
  }
}

export function canCancelProductOdin(subscriptionId, callback, callbackFail) {
  return (dispatch, getState) => {
    const customerId = _get(getState().customer, "data.documentNumber", "")
    const config = {
      pathValues: {
        customerId,
        subscriptionId
      },
      client: "sensedia",
      data: {
        protocolo: "",
        inadimplencia: false,
        productId: subscriptionId
      }
    }
    const request = remove("cancelProductOdin", config)

    return dispatch({
      type: ActionTypes.CANCEL_SUBSCRIPTION,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function plantUpdatedSuccess() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.PLANT_UPDATED_SUCCESS
    })
  }
}

export function getMenu(product, callback) {
  return (dispatch) => {
    if (product.productSystem !== "ALGAR CRM") {
      Promise.all([
        dispatch(getProductDetail(product, callback)),
        dispatch(canCancelProduct(product, callback))
      ])
    } else {
      dispatch(getProductDetail(product, callback))
    }
  }
}

export function selectProduct(product) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SELECT_PRODUCT,
      payload: product
    })
  }
}

export function sendProductsPlantByEmail(params, callback) {
  return (dispatch, getState) => {
    const config = { params, client: BFF }
    const request = get("sendProductsPlantByEmail", config)

    let type = ""

    if (config.params.fileType) {
      if (config.params.fileType === "PDF") {
        type = "SENDBYEMAIL_PDF"
      } else if (config.params.fileType === "EXCEL") {
        type = "SENDBYEMAIL_EXCEL"
      }
    }
    dispatch({
      type: ActionTypes.SEND_PRODUCTS_PLANT_BY_EMAIL,
      payload: request
    })
      .then(
        success(() => {
          dispatch(
            saveOperation(
              getState().customer.data,
              "",
              "PRODUCTS_PLANT",
              type,
              "SUCCESS",
              "",
              "Planta de Produtos"
            )
          )
        })
      )
      .then(success(callback))
      .catch((error) => {
        console.error(error)

        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            "PRODUCTS_PLANT",
            type,
            "ERROR",
            "",
            "Planta de Produtos"
          )
        )
      })
  }
}

export function dismissProductsPlantNotification() {
  return (dispatch) => {
    dispatch({ type: ActionTypes.SEND_PRODUCTS_PLANT_BY_EMAIL_DISMISS })
  }
}

export function getMonthsDetailing(invoices) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.MONTHS_DETAILING,
      payload: invoices
    })
  }
}

export function downloadCounts(data) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.MONTHS_LOADER,
      payload: true
    })
    const productKey = data.productKey

    const listSelected = getState().products.data.find(
      (item) => item.lineOfBusiness === "TELEFONIA MOVEL"
    )

    const selected = listSelected.products.find(
      (item) => item.productKey === productKey
    )

    let paymentMode

    if (selected != null) {
      if (selected.paymentMode === "PREPAGO") {
        paymentMode = "DETAILING_PRE"
      } else {
        paymentMode = "DETAILING_POS"
      }
    }

    const billingSystem = getState().products.detail.data.billingSystem

    const payload = {
      phoneNumber: data.serviceId,
      fileType: "PHONE_DETAILS",
      paymentMode: data.paymentMode,
      systemBilling: billingSystem.toUpperCase(),
      monthYear: data.checkeds,
      format: "PDF"
    }

    const request = post("downloadFileDetails", {
      data: payload,
      client: BFF,
      responseType: "blob"
    })

    dispatch({
      type: ActionTypes.MONTHS_DETAILING_DOWNLOAD,
      payload: request
    })
      .then((response) => {
        return {
          blob: new Blob([response.payload.data], {
            type: response.payload.headers["content-type"]
          }),
          filename:
            response.payload.headers["content-type"] ===
            "application/octet-stream"
              ? "DETALHAMENTOS.zip"
              : ""
        }
      })
      .then((response) => {
        sendGtmEventFileDownload("Download de detalhamento pré-pago")

        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            paymentMode,
            "DOWNLOAD",
            "SUCCESS",
            "",
            "Download de detalhamento pré-pago"
          )
        )

        const url = window.URL.createObjectURL(response.blob)
        const link = document.createElement("a")
        link.href = url
        link.target = "_blank"
        if (response.filename) {
          link.download = response.filename
        }
        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link)

        dispatch({
          type: ActionTypes.MONTHS_LOADER,
          payload: false
        })
      })
      .catch((error) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            paymentMode,
            "DOWNLOAD",
            "ERROR",
            "",
            "Download de detalhamento pré-pago"
          )
        )

        dispatch({
          type: ActionTypes.MONTHS_LOADER,
          payload: false
        })
        console.error("Error: ", error)
      })
    return null
  }
}

export function setError() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_ERROR_DOWNLOAD
    })
  }
}

export function getBanks() {
  return (dispatch) => {
    const request = get("banks", { client: BFF })
    dispatch({
      type: ActionTypes.GET_BANKS,
      payload: request
    })
  }
}

export function getBankData(accountNumber) {
  return (dispatch) => {
    const config = { pathValues: { accountNumber }, client: BFF }
    const request = get("bankData", config)
    dispatch({
      type: ActionTypes.GET_BANK_DATA,
      payload: request
    })
  }
}

export function monthsDetailingLoader(bool) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.MONTHS_LOADER,
      payload: bool
    })
  }
}

export function detailingSend({ keys, email, phoneNumber, paymentMode }) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.MONTHS_LOADER,
      payload: true
    })

    const state = getState()
    const billingSystem = state.products.detail.data.billingSystem

    const data = {
      fileType: "PHONE_DETAILS",
      format: "PDF",
      email,
      invoices: keys,
      systemBilling: billingSystem.toUpperCase(),
      name: state.customer.data.name,
      customerSegment: state.customer.data.customerSegment,
      phoneNumber,
      paymentMode
    }

    const config = { data, client: BFF }
    const request = post("sendInvoiceByEmail", config)

    dispatch({
      type: ActionTypes.MONTHS_DETAILING_EMAILS,
      payload: request
    })
      .then((response) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            paymentMode,
            "SENDBYEMAIL",
            "SUCCESS",
            "",
            "Download de detalhamento pré-pago"
          )
        )
      })
      .catch((error) => {
        console.error(error)

        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            paymentMode,
            "SENDBYEMAIL",
            "ERROR",
            "",
            "Download de detalhamento pré-pago"
          )
        )
        dispatch(
          saveOperation(
            getState().customer.data,
            "",
            paymentMode,
            "SENDBYEMAIL",
            "ERROR",
            "",
            "Download de detalhamento pré-pago"
          )
        )
      })
  }
}

export function saveDebit({ accountNumber, form, typeDebit }) {
  return (dispatch, getState) => {
    const config = {
      pathValues: { accountNumber },
      data: form,
      raw: true,
      client: BFF
    }
    const request = post("activeDebitCard", config)
    dispatch({
      type: ActionTypes.SAVE_DEBIT,
      payload: request,
      typeDebit
    })
      .then((response) => {
        let protocol, status

        if (response.type === "SAVE_DEBIT_FAIL") {
          status = "ERROR"
        } else {
          status = "SUCCESS"
        }

        if (!!response && !!response.payload && !!response.payload.data) {
          protocol = response.payload.data.resultMessage
        }
        dispatch(
          saveOperation(
            getState().customer.data,
            accountNumber,
            "AUTOMATIC_DEBIT",
            "SUBMIT",
            status,
            protocol,
            "Débito automático"
          )
        )
      })
      .catch((error) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            accountNumber,
            "AUTOMATIC_DEBIT",
            "SUBMIT",
            "ERROR",
            "",
            "Débito automático"
          )
        )
        console.error("Error: ", error)
      })
  }
}

export function removeDebit({ accountNumber, form, typeDebit }) {
  return (dispatch, getState) => {
    const config = {
      pathValues: { accountNumber },
      data: form,
      raw: true,
      client: BFF
    }
    const request = remove("activeDebitCard", config)
    dispatch({
      type: ActionTypes.DELETE_DEBIT,
      payload: request,
      typeDebit
    })
      .then((response) => {
        let protocol, status

        if (response.type === "DELETE_DEBIT_FAIL") {
          status = "ERROR"
        } else {
          status = "SUCCESS"
        }

        if (!!response && !!response.payload && !!response.payload.data) {
          protocol = response.payload.data.resultMessage
        }
        dispatch(
          saveOperation(
            getState().customer.data,
            accountNumber,
            "AUTOMATIC_DEBIT",
            "SUBMIT",
            status,
            protocol,
            "Débito automático"
          )
        )
      })
      .catch((error) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            accountNumber,
            "AUTOMATIC_DEBIT",
            "SUBMIT",
            "ERROR",
            "",
            "Débito automático"
          )
        )
        console.error("Error: ", error)
      })
  }
}

export function saveMoreDebits({ forms }) {
  return (dispatch) => {
    const promises = []
    const allResponses = []
    dispatch({
      type: ActionTypes.CHANGE_LOADER,
      payload: true
    })
    forms.map((item) => {
      const accountNumber = item.accountNumber
      const formSend = item.form
      const config = {
        pathValues: { accountNumber },
        data: formSend,
        raw: true
      }
      const request = post("activeDebitCard", config)
      return promises.push(
        dispatch({
          type: ActionTypes.REQUEST_DEBIT,
          payload: request
        })
          .then((response) => {
            const responseReturn = response.error
              ? response.error.response.data
              : response.payload.data
            responseReturn.accountNumber = item.accountNumber
            return allResponses.push(responseReturn)
          })
          .catch((error) => {
            console.error("Error: ", error)
          })
      )
    })

    Promise.all(promises).then(() =>
      dispatch({
        type: ActionTypes.ALL_SAVE_MORE_DEBITS,
        payload: allResponses
      })
    )
  }
}

function unlockByTrustValidate(payload) {
  const { serviceId } = payload
  let objUnlockByTrusty = []
  const obj = window.localStorage.getItem("setUnlockByTrusty")
  const normalize = JSON.parse(obj)

  if (!normalize) {
    objUnlockByTrusty = _concat(payload)
    return window.localStorage.setItem(
      "setUnlockByTrusty",
      JSON.stringify(objUnlockByTrusty)
    )
  }
  const findDuplicity = _find(normalize, (item) => item.serviceId === serviceId)

  if (!findDuplicity) {
    objUnlockByTrusty = _concat(normalize, payload)
    return window.localStorage.setItem(
      "setUnlockByTrusty",
      JSON.stringify(objUnlockByTrusty)
    )
  }
}

export function updateProductDetails({
  contractKey,
  productKey,
  operation,
  date,
  payload
}) {
  return (dispatch, getState) => {
    const pathValues = { contractKey, productKey }

    const { contactPhoneNumber, daysSuspended, operationIndicator } = operation

    const data = date
      ? { contactPhoneNumber, daysSuspended, operationIndicator }
      : { operationIndicator: operation }

    const config = { pathValues, data, raw: true }

    const request = put("updateProductDetails", config)
    dispatch({
      type: ActionTypes.UPDATE_PRODUCTS_DETAILS,
      payload: request
    })
      .then((response) => {
        if (response.type === "UPDATE_PRODUCTS_DETAILS_SUCCESS") {
          unlockByTrustValidate(payload)
        }

        if (data.operationIndicator === "ACTIVATE_PROVISIONAL_SUSPENSION") {
          let protocol, status

          if (response.type === "UPDATE_PRODUCTS_DETAILS_FAIL") {
            status = "ERROR"
          } else {
            status = "SUCCESS"
          }

          if (!!response && !!response.data && !!response.data.resultData) {
            protocol = response.data.resultData.protocolNumber
          }

          dispatch(
            saveOperation(
              getState().customer.data,
              "",
              "PROVISIONAL_SUSPENSION",
              "SUBMIT",
              status,
              protocol,
              "Suspensão Provisória"
            )
          )
        }
      })
      .catch((error) => {
        console.error(error)

        if (data.operationIndicator === "ACTIVATE_PROVISIONAL_SUSPENSION") {
          dispatch(
            saveOperation(
              getState().customer.data,
              "",
              "PROVISIONAL_SUSPENSION",
              "SUBMIT",
              "ERROR",
              "",
              "Suspensão Provisória"
            )
          )
        }
      })
  }
}

export function unblockProductInTrust(payload, callback, callbackFail) {
  return (dispatch) => {
    const config = { data: payload, client: BFF }
    const request = post("unblockInTrust", config)

    return dispatch({ type: ActionTypes.GET_PRODUCTS, payload: request }).then(
      dispatchHandler(callback, callbackFail)
    )
  }
}

export function getPossibleExpirationDates({ agreementId }) {
  return (dispatch, getState) => {
    let dueDate = []
    if (getState().bills.selected.billingSystem === "KENAN") {
      dueDate = ["", 3, 7, 11, 16, 20, 24, 28]
    } else if (getState().bills.selected.billingSystem === "CPQD") {
      dueDate = ["", 1, 5, 10, 15, 20, 21, 28, 30, 31]
    } else if (getState().bills.selected.billingSystem === "CONTROLPLUS") {
      dueDate = ["", 3, 7, 16, 20, 24, 28]
    } else {
      dueDate = ["", 3, 7, 11, 16, 20, 24, 28]
    }
    dispatch({
      type: ActionTypes.POSSIBLE_EXPIRATION_DATES_SUCCESS,
      payload: dueDate
    })
  }
}

export function suspension({ contractKey, productKey, operation, date }) {
  return (dispatch) => {
    const pathValues = { contractKey, productKey }

    const { contactPhoneNumber, daysSuspended, operationIndicator } = operation

    const data = date
      ? { contactPhoneNumber, daysSuspended, operationIndicator }
      : { operationIndicator: operation }

    const config = { pathValues, data, raw: true }

    const request = put("updateProductDetails", config)
    dispatch({
      type: ActionTypes.UPDATE_PRODUCTS_DETAILS,
      payload: request
    })
  }
}

export function cancellation({ data, email, serviceId }) {
  return (dispatch, getState) => {
    const config = {
      data,
      params: { email }
    }

    const request = put("cancellation", config, email)
    dispatch({
      type: ActionTypes.CANCELLATION,
      payload: request
    })
      .then((response) => {
        const currentState = getState()
        const typeModal = _get(currentState, "updateProducts.type")
        const protocol = _get(response, "payload.protocolNumber", "")

        if (!protocol || typeModal === "error") {
          dispatch(
            saveOperation(
              currentState.customer.data,
              serviceId,
              "PRODUCT_CANCELLATION",
              "SUBMIT",
              "ERROR",
              "",
              "Solicitação de Cancelamento"
            )
          )
        } else if (typeModal === "progress") {
          dispatch(
            saveOperation(
              currentState.customer.data,
              serviceId,
              "PRODUCT_CANCELLATION",
              "SUBMIT",
              "WARNING",
              "",
              "Solicitação de Cancelamento"
            )
          )
        } else {
          dispatch(
            saveOperation(
              currentState.customer.data,
              serviceId,
              "PRODUCT_CANCELLATION",
              "SUBMIT",
              "SUCCESS",
              protocol,
              "Solicitação de Cancelamento"
            )
          )
        }
      })
      .catch((error) => {
        const currentState = getState()
        dispatch(
          saveOperation(
            currentState.customer.data,
            serviceId,
            "PRODUCT_CANCELLATION",
            "SUBMIT",
            "ERROR",
            "",
            "Solicitação de Cancelamento"
          )
        )
        console.error("Error: ", error)
      })
  }
}

export function normalizeBill(bill) {
  if (!!bill && !!bill.agreementId) {
    if (typeof bill.agreementId === "string") {
      const agreementId = bill.agreementId.split(";")[0]
      if (typeof agreementId.charAt(0) === "string") {
        return agreementId.substr(1)
      }
    }

    return bill.agreementId
  }
}

function normalizeExpirationDate(dueDate, bill) {
  return {
    dueDate,
    agreementId: normalizeBill(bill),
    targetSystem: normalizeTargetSystem(bill),
    townCode: bill.townCode,
    accountNumber: bill.accountNumber,
    billingSystem: bill.billingSystem,
    productId: bill.productId,
    destinationSystem: normalizeTargetSystem(bill)
  }
}

export function changeExpirationDate(dueDate) {
  return (dispatch, getState) => {
    const bill = getState().bills.selected
    const accountNumber = bill.accountNumber

    const config = {
      client: BFF,
      pathValues: { accountNumber },
      data: normalizeExpirationDate(dueDate, bill),
      raw: true
    }

    const request = put("changeDueDate", config)

    dispatch({
      type: ActionTypes.CHANGE_EXPIRATION_DATE,
      payload: request
    })
      .then((result) => {
        let status, protocol

        if (!!result && !!result.payload && !!result.payload.data) {
          protocol = result.payload.data.resultMessage
        }

        if (result.type === "CHANGE_EXPIRATION_DATE_FAIL") {
          status = "ERROR"
        } else {
          status = "SUCCESS"
        }

        dispatch(
          saveOperation(
            getState().customer.data,
            bill.billingAccountNumber,
            "CHANGE_DUE_DATE",
            "SUBMIT",
            status,
            protocol,
            "Data de Vencimento"
          )
        )
      })
      .catch((response) => {
        dispatch(
          saveOperation(
            getState().customer.data,
            bill.billingAccountNumber,
            "CHANGE_DUE_DATE",
            "SUBMIT",
            "ERROR",
            "",
            "Data de Vencimento"
          )
        )
      })
  }
}

export function setModal() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_MODAL
    })
  }
}

export function setDebit() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_DEBIT
    })
  }
}

export function downloadDetails({
  serviceId,
  customerName,
  customerSegment,
  startDate,
  endDate
}) {
  return (dispatch) => {
    const pathValues = {
      serviceId
    }
    const data = {
      customerName,
      customerSegment,
      startDate,
      endDate
    }
    const config = { pathValues, data, client: BFF }
    const request = post("downloadTraffic", config)

    dispatch({
      type: ActionTypes.DOWNLOAD_TRAFFIC_DETAILS,
      payload: request
    }).then((result) => {
      const file = result.payload.data.pathURL
      const link = document.createElement("a")
      link.href = file
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  }
}

export function sendTrafficEmail({ serviceId }, data) {
  return (dispatch) => {
    const pathValues = {
      serviceId
    }
    const config = { pathValues, data, client: BFF }
    const request = post("sendTrafficMail", config)

    dispatch({
      type: ActionTypes.SEND_TRAFFIC_EMAIL,
      payload: request
    })
  }
}

export function getTrafficDetails({ startDate, endDate, serviceId }) {
  return (dispatch) => {
    const pathValues = { serviceId, startDate, endDate }
    const config = { pathValues, client: BFF }
    const request = get("dataTrafficDetails", config)

    dispatch({
      type: ActionTypes.GET_TRAFFIC_DETAILS,
      payload: request
    })
  }
}

export function getTrafficSummary({ contractId }) {
  return (dispatch) => {
    const config = { pathValues: { contractId }, client: BFF }
    const request = get("dataTraffic", config)

    dispatch({
      type: ActionTypes.GET_TRAFFIC_SUMMARY,
      payload: request
    })
  }
}

export function getBillingAccountAliasName() {
  return (dispatch, getState) => {
    const bills = getState().bills || {}
    const config = {
      client: BFF
    }
    const request = get("getBillingAccountAlias", config)

    dispatch({
      type: ActionTypes.GET_ACCOUNT_ALIAS_NAME,
      payload: request
    }).then(
      success(
        dispatchHandler(() => {
          // eslint-disable-next-line no-unused-expressions
          bills.selected
            ? dispatch(
                selectBillByAccountNumber(
                  bills.data,
                  bills.selected.accountNumber
                )
              )
            : null
        })
      )
    )
  }
}

export function changeBillingAccountAliasName(bill, alias) {
  return (dispatch, getState) => {
    const billAccount = bill.billingAccountNumber || bill.accountNumber
    const config = {
      client: BFF,
      data: [
        {
          alias,
          billAccount
        }
      ]
    }
    const request = post("setBillingAccountAlias", config)

    dispatch({
      type: ActionTypes.SET_ACCOUNT_ALIAS_NAME,
      payload: request
    })
      .then(
        success(() => {
          dispatch(
            saveOperation(
              getState().customer.data,
              bill.billingAccountNumber,
              "ALIAS_BILLING_ACCOUNT",
              "SUBMIT",
              "SUCCESS",
              "",
              "Apelido Conta de Faturamento"
            )
          )

          dispatch(getBillingAccountAliasName())
        })
      )
      .catch((error) => {
        console.error(error)

        dispatch(
          saveOperation(
            getState().customer.data,
            bill.billingAccountNumber,
            "ALIAS_BILLING_ACCOUNT",
            "SUBMIT",
            "ERROR",
            "",
            "Apelido Conta de Faturamento"
          )
        )
      })
  }
}

export function deleteBillingAccountAliasName(bill) {
  return (dispatch, getState) => {
    const billAccount = bill.billingAccountNumber || bill.accountNumber
    const config = {
      client: BFF,
      params: { billAccount }
    }

    const request = remove("deleteBillingAccountAlias", config)

    dispatch({
      type: ActionTypes.DELETE_ACCOUNT_ALIAS_NAME,
      payload: request
    })
      .then(
        success((p) => {
          dispatch(
            saveOperation(
              getState().customer.data,
              bill.billingAccountNumber,
              "ALIAS_BILLING_ACCOUNT",
              "DELETE",
              "SUCCESS",
              "",
              "Apelido Conta de Faturamento"
            )
          )

          dispatch(getBillingAccountAliasName())
        })
      )
      .catch((error) => {
        console.error(error)

        dispatch(
          saveOperation(
            getState().customer.data,
            bill.billingAccountNumber,
            "ALIAS_BILLING_ACCOUNT",
            "DELETE",
            "ERROR",
            "",
            "Apelido Conta de Faturamento"
          )
        )
      })
  }
}

export function closeSuccessModal() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_ACCOUNT_ALIAS_NAME_CLOSE_SUCCESS
    })
  }
}

export function generateSVAToken(data) {
  return (dispatch) => {
    const config = { data, client: BFF }
    const request = post("generateSVAToken", config)
    dispatch({
      type: ActionTypes.GENERATE_SVA_TOKEN,
      payload: request
    })
  }
}

export function getAllProducts(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = { useMock: false, pathValues: queryParams, client: "" }
    const request = get("getAllProducts", config)

    return dispatch({
      type: ActionTypes.GET_ALL_PRODUCTS,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getAssetDetails(queryParams, callback, callbackFail) {
  return (dispatch) => {
    const config = { useMock: false, pathValues: queryParams, client: BFF }
    const request = get("getAssetDetailsV2", config)

    return dispatch({
      type: ActionTypes.GET_ASSET_DETAILS,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getInvoicesSummary(data, callback, callbackFail) {
  return (dispatch, getState) => {
    const billingAccount = _get(data, ["billingAccount"], "")
    const headOfficeDocumentNumber = _get(
      getState().customer.data,
      ["documentNumber"],
      ""
    )
    const documentNumber = _get(data, ["cnpj"], "")

    const config = {
      params: {
        ...data,
        cnpj:
          documentNumber === "0" ? headOfficeDocumentNumber : documentNumber,
        withSubsidiaries: documentNumber === "0" ? "1" : "0",
        billingAccount: billingAccount === "0" ? null : billingAccount
      },
      useMock: false,
      client: BFF
    }
    const request = get("getInvoicesSummary", config)

    return dispatch({
      type: ActionTypes.GET_INVOICES_SUMMARY,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getInvoicesHistoric(data, callback, callbackFail) {
  return (dispatch, getState) => {
    const headOfficeDocumentNumber = _get(
      getState().customer.data,
      ["documentNumber"],
      ""
    )

    const status = _get(data, ["status"], "")
    const documentNumber = _get(data, ["cnpj"], "")
    const billingAccount = _get(data, ["billingAccount"], "")
    const startDueDate = _get(data, ["startDueDate"], "")
    const endDueDate = _get(data, ["endDueDate"], "")
    const startEmissionDate = _get(data, ["startEmissionDate"], "")
    const endEmissionDate = _get(data, ["endEmissionDate"], "")
    const assetId = _get(data, ["assetId"], "")
    const page = _get(data, ["page"], 1)
    const limit = _get(data, ["limit"], 10)

    const config = {
      params: {
        page,
        limit,
        cnpj:
          documentNumber === "0" ? headOfficeDocumentNumber : documentNumber,
        withSubsidiaries: documentNumber === "0" ? "1" : "0",
        status: status === "0" ? null : status,
        billingAccount: billingAccount === "0" ? null : billingAccount,
        assetId: assetId === "0" ? null : assetId,
        startDueDate: !startDueDate
          ? null
          : moment(startDueDate).format("DD/MM/YYYY"),
        endDueDate: !endDueDate
          ? null
          : moment(endDueDate).format("DD/MM/YYYY"),
        startEmissionDate: !startEmissionDate
          ? null
          : moment(startEmissionDate).format("DD/MM/YYYY"),
        endEmissionDate: !endEmissionDate
          ? null
          : moment(endEmissionDate).format("DD/MM/YYYY")
      },
      useMock: false,
      client: BFF
    }
    const request = get("getInvoicesHistoric", config)

    return dispatch({
      type: ActionTypes.GET_INVOICES_HISTORIC,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getProductsInInvoice(
  documentNumber,
  assets,
  callback,
  callbackFail
) {
  return (dispatch) => {
    const config = {
      data: { documentNumber, assets },
      client: BFF
    }
    const request = post("getProductsInInvoice", config)

    return dispatch({
      type: ActionTypes.GET_PRODUCTS_INVOICE,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}



// WEBPACK FOOTER //
// ./src/services/state/billing/action.js